import { useEffect, useState } from 'react'
import { getGeneric } from '../../common/constants'

// About PACE → Signals (merchant panel). Every signal the served PACE model reads and which of
// them this merchant's settings use for ranking. The proship relay always applies the
// logged-in merchant (PaceSignalsController /api/ruleengine/pace-signals); no merchant param.
export const fetchPaceSignals = (_merchantId, paymentMode) =>
  getGeneric('ruleengine/pace-signals', paymentMode ? { paymentMode } : {}).then((r) => r.data)

// Signal count for the headline numbers on the other tabs; one fetch per page load.
let countPromise = null
export function useSignalCount(fallback = 165) {
  const [n, setN] = useState(fallback)
  useEffect(() => {
    let live = true
    countPromise = countPromise || fetchPaceSignals().then((d) => d.n_signals).catch(() => null)
    countPromise.then((v) => { if (live && v) setN(v) })
    return () => { live = false }
  }, [])
  return n
}
